import { API_BASE_URL } from "../api";

interface ImageOptions {
    width?: number;
    height?: number;
    quality?: number;
}

/**
 * ストレージから画像のURLを取得する
 */
export const getStorageImageUrl = async (
    bucket: string,
    storagePath: string,
    _options: ImageOptions = { width: 320, height: 320, quality: 80 },
): Promise<string> => {
    return `${API_BASE_URL}/storage/${bucket}/${storagePath}`;
};

/**
 * ストレージから画像のpublicURLを取得する
 */
export const getPublicUrl = async (bucket: string, storagePath: string) => {
    return `${API_BASE_URL}/storage/${bucket}/${storagePath}`;
};

// URLの有効期限をチェックする関数 (ローカルでは常に有効)
export const isUrlExpired = (_url: string): boolean => {
    return false;
};

// バケット名の定数
export const STORAGE_BUCKETS = {
    ILLUSTRATIONS: "illustrations",
    THUMBNAILS: "thumbnails",
    FEATURES: "features",
} as const;

export type StorageBucket =
    typeof STORAGE_BUCKETS[keyof typeof STORAGE_BUCKETS];
